import { FC } from 'react'
import {
    Outlet
} from "react-router-dom";


const SpentPage: FC = () => {  
    return (
        <Outlet />
    );
}

export default SpentPage